export default "__VITE_ASSET__DA$_sXyg__"